import format from "date-fns/format";
import React from "react";
import { Ticket } from "../../../models/Ticket";
import "./changeDate.scss";
import "../../../../style/alerts.scss";
import { useTranslation } from "react-i18next";

interface IProps {
  ticket: Ticket;
  alert: string;
}

const FutureTicketChange: React.FC<IProps> = ({ ticket, alert }: IProps) => {
  const { t } = useTranslation();
  return (
    <React.Fragment>
      <div className="future-ticket-change">
        <div className="future-ticket-change-dialog">
          <span>{t("aby_zmienic_termin_najpierw_musisz_zrezygnowac_z_obecnego")}</span>
          {ticket.exercises && (
            <div className="alert alert-yellow">
              <b>{ticket.exercises[0].name}</b>
              <span>
                {format(ticket.exercises[0].startTime, "yyyy-MM-dd")} / {t("godz")}
                {format(ticket.exercises[0].startTime, "HH:mm")}
              </span>
            </div>
          )}
        </div>
        {alert.length > 2 && (
          <div className="alert alert-second">
            <b>{alert}</b>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default FutureTicketChange;
